import { useOutletContext } from "react-router";
import type { ProjectOverview } from "../../api/projectsApi";
import type { ProjectSettings } from "../../api/settingsApi";

/** What every tab of a project's settings reads from `ProjectSettingsLayout`. */
export interface ProjectSettingsContext {
  readonly overview: ProjectOverview;
  readonly settings: ProjectSettings;
  /** Who may do what changed: read again what the user may do, here and in the project menu. */
  readonly permissionsChanged: () => void;
  readonly settingsChanged: () => void;
}

export function useProjectSettings(): ProjectSettingsContext {
  return useOutletContext<ProjectSettingsContext>();
}
